/**
 * The domain packs this build knows. To add a domain: write src/domains/<name>/pack.ts and list it here.
 * The pack is chosen by the backend's domain (`GET /api/runtime` → domain), or for an old recording
 * by which pack recognises its session.
 */
import type { DomainPack } from '@platform/packs/contract';
import type { Session } from '@platform/core/wire';
import { bankPack } from '@domains/bank/pack';
import { trainsPack } from '@domains/trains/pack';

export const PACKS: readonly DomainPack[] = [trainsPack, bankPack];

export function packFor(domain: string | null | undefined, session: Session | null): DomainPack | null {
  if (domain) return PACKS.find((p) => p.id === domain) ?? null;
  if (session) return PACKS.find((p) => p.recognizes(session)) ?? null;
  return null;
}
